import { Box, Container, Stack } from "@mui/material";
import { HeaderMinimal } from "src/components/Header";
import { Article, LegalNotice } from "src/components/LegalNotice";

import { PromotionHeader } from "./components/PromotionHeader";
import { PromotionPreamble } from "./components/PromotionPreamble";
import { PROMOTION_ARTICLES } from "./promotionConfig";

export const Promotion = () => {
  return (
    <>
      <HeaderMinimal />

      <Container component="main">
        <Stack py={12}>
          <PromotionHeader />

          <Box mt={7}>
            <LegalNotice>
              <PromotionPreamble />
              {PROMOTION_ARTICLES.map((article, articleIndex) => (
                <Article
                  key={article.title}
                  {...article}
                  articleNo={articleIndex + 1}
                />
              ))}
            </LegalNotice>
          </Box>
        </Stack>
      </Container>
    </>
  );
};
